<template>
  <div>
    <v-timeline-item
      v-for="item in historyItems"
      :color="item.icon.color"
      :icon="item.icon.code"
      v-bind:key="item.id"
      fill-dot
      small
    >
      <v-row>
        <h4 class="mr-1">{{ item.user }}</h4>
        <span>{{ item.type }}</span>
        <v-spacer />
        <v-icon class="mr-2">mdi-clock</v-icon>
        <span class="mr-1">{{ item.time }}</span>
      </v-row>
      <v-row v-if="item.description">
        <span class="text-subtitle-1 font-italic">{{ item.description }}</span>
      </v-row>
    </v-timeline-item>
  </div>
</template>
<script>
export default {
  props: {
    historyItems: {
      type: Array,
    },
  },
};
</script>